import React, { useContext } from 'react';
import { Collapse, Navbar, NavItem, Nav } from 'reactstrap';
import classNames from 'classnames';
import AppContext from '../../context/Context';
import Logo from './Logo';
import SearchBox from './SearchBox';
import FindBox from '../find/FindBox';
import { newSearch } from '../../helpers/findApi';
import TopNavRightSideNavItem from './TopNavRightSideNavItem';
import NavbarTopDropDownMenus from './NavbarTopDropDownMenus';
import { navbarBreakPoint, topNavbarBreakpoint } from '../../config';

const NavbarTop = () => {
  const {
    showBurgerMenu,
    setShowBurgerMenu,
    isTopNav,
    isVertical,
    isCombo,
    navbarCollapsed,
    setNavbarCollapsed,
    autoCompleteHistory
  } = useContext(AppContext);

  const handleBurgerMenu = () => {
    isTopNav && !isCombo && setNavbarCollapsed(!navbarCollapsed);
    (isCombo || isVertical) && setShowBurgerMenu(!showBurgerMenu);
  };
  return (
    <Navbar
      light
      className={classNames('navbar-glass fs--1 font-weight-semi-bold row navbar-top sticky-kit', { 'flex-nowrap': newSearch() })}
      expand={isTopNav && topNavbarBreakpoint}
    >
      <div
        className={classNames('toggle-icon-wrapper mr-md-3 mr-2', {
          'd-lg-none': isTopNav && !isCombo,
          [`d-${navbarBreakPoint}-none`]: isVertical || isCombo
        })}
      >
        <button
          className="navbar-toggler-humburger-icon btn btn-link d-flex flex-center"
          onClick={handleBurgerMenu}
          id="burgerMenu"
        >
          <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span>
        </button>
      </div>
      {/* On phones the new search needs the room the lettering takes; the icon stays. */}
      <Logo at="navbar-top" width={40} id="topLogo" textClassName={newSearch() ? 'd-none d-sm-inline' : undefined} />
      {isTopNav ? (
        <Collapse navbar isOpen={navbarCollapsed} className="scrollbar">
          <Nav navbar>
            <NavbarTopDropDownMenus setNavbarCollapsed={setNavbarCollapsed} />
          </Nav>
        </Collapse>
      ) : (
        <Nav navbar className={newSearch() ? 'align-items-center d-flex flex-grow-1 mx-2' : `align-items-center d-none d-${topNavbarBreakpoint}-block`}
          style={newSearch() ? { minWidth: 0 } : undefined}>
          {/* The search bar of the new search fills the row up to the icons on the right, at every width. */}
          <NavItem className={classNames({ 'w-100': newSearch() })}>
            {newSearch() ? <FindBox /> : <SearchBox autoCompleteItem={autoCompleteHistory} />}
          </NavItem>
        </Nav>
      )}

      <TopNavRightSideNavItem />
    </Navbar>
  );
};

export default NavbarTop;
